module.exports = __webpack_public_path__ + "media/images/brands/logo_ekz-27749b3a6a81a5adc9d344766f20874b.svg";